import React from "react"

import FieldTaskAssignedToUser from "../assigned-to-user"
import {FieldGoalListEditableProps} from "../../../../../render/goal-list/goal-list-editable"
import {FieldPickerType} from "../../../../../render/picker"
import HintPopover from "../../../../../../gd-ui/hint-popover/hint-popover"

type Props = {
    field: FieldTaskAssignedToUser
} & FieldGoalListEditableProps

const debug = false
// const debug = "FieldTaskAssignedToUser_GoalListEditable"

export default class FieldTaskAssignedToUser_GoalListEditable extends React.Component<Props,any> {

    public previousValue        : any

    constructor(props:Props) {
        super(props);

        const value = _.get(props.model, props.field.fieldId, null)

        this.state = {
            initialPropsValue: value, // required to check if currentOption update needed on props changed
            currentValue: value,
            showPopover: false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId] // new value

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentValue       : props.field._getOption(value)?.value
            }
        }

        return null // no changes
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    // for compatibility with dropdown PopoverMenu (BaseDropdownPopoverMenu)
    onOptionClick = (option:any) => {this.onValueChange(option ? option.value : option)}

    onValueChange = (value:any) => {
        this.previousValue = this.state.currentValue;
        const newValue = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {
            // if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange);
            if (this.props.onChange) this.props.onChange(newValue);
            this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    render() {
        const {field} = this.props

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        })

        const showHint = _.get(this.props.configOptions, 'showHint', true)

        debug && console.log(debug, 'render', this.state, this.props)

        // need check value because of none
        if (!_.isNil(this.state.currentValue)) {
            return (
                <field.components.PickerValueNotEmpty {...this.props}
                                                      className = {classes}
                                                      type      = {FieldPickerType.CIRCLE}
                                                      field     = {field}
                                                      value     = {this.state.currentValue}
                                                      onClick   = {this.showPopover}
                                                      onDelete  = {this.onOptionClick}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                    {!this.state.showPopover && showHint && <HintPopover parent={this} hint={this.props.field.label}/>}
                </field.components.PickerValueNotEmpty>
            )
        }

        // no value
        return (
            <field.components.PickerValueEmpty {...this.props}
                                               className    = {classes}
                                               type         = {FieldPickerType.CIRCLE}
                                               field        = {this.props.field}
                                               value        = {this.state.currentValue}
                                               onClick      = {this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                {!this.state.showPopover && showHint && <HintPopover parent={this} hint={this.props.field.label}/>}
            </field.components.PickerValueEmpty>
        )
    }
}

